import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, ChevronRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { EmptyState } from "@/components/Bits";

const JoinerRow = ({ j, i }) => (
  <Link
    to={`/joiners/${j.id}`}
    data-testid={`joiner-row-${j.id}`}
    style={{ animationDelay: `${Math.min(i, 12) * 30}ms` }}
    className="rise group flex items-center gap-4 rounded-2xl border border-white/5 bg-zinc-900/60 px-4 py-3.5 transition-colors duration-200 hover:border-violet-500/40 hover:bg-zinc-900"
  >
    <span className="min-w-0 flex-1 font-semibold truncate">{j.name}</span>
    {j.past_due && <span data-testid={`joiner-past-due-tag-${j.id}`} className="shrink-0 rounded-full bg-red-500/15 border border-red-500/40 px-2 py-0.5 text-[11px] font-bold text-red-300">Past due</span>}
    {j.due_soon && <span data-testid={`joiner-due-soon-tag-${j.id}`} className="shrink-0 rounded-full bg-amber-400/15 border border-amber-400/40 px-2 py-0.5 text-[11px] font-bold text-amber-200">Due soon</span>}
    <ChevronRight className="h-4 w-4 text-zinc-600 transition-transform duration-200 group-hover:translate-x-1" />
  </Link>
);

export default function Joiners() {
  const [joiners, setJoiners] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api.get("/joiners").then((r) => setJoiners(r.data)).catch(() => setJoiners([]));
  }, []);
  const filtered = useMemo(
    () => (joiners || []).filter((j) => `${j.name} ${j.handle}`.toLowerCase().includes(q.toLowerCase())),
    [joiners, q]
  );

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-end gap-4 justify-between">
        <div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight">Joiners</h1>
          <p className="text-zinc-400 mt-2 text-sm md:text-base">Tap your name to see your claims, payments and balance.</p>
        </div>
        <div className="relative w-full sm:w-80">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500" />
          <Input data-testid="joiner-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your name" className="pl-9 h-11 rounded-xl bg-zinc-900 border-zinc-800" />
        </div>
      </div>
      <div className="mt-8 space-y-2.5" data-testid="joiners-list">
        {joiners === null && <div className="text-zinc-500 text-sm">Loading…</div>}
        {joiners && filtered.length === 0 && (
          <EmptyState testId="joiners-empty" title={joiners.length ? "No match" : "No joiners yet"} hint={joiners.length ? "Try a different spelling." : "Admins add joiners from the admin panel."} />
        )}
        {filtered.map((j, i) => <JoinerRow key={j.id} j={j} i={i} />)}
      </div>
    </div>
  );
}
